import React, { useEffect, useMemo, useState } from "react";
import { useAuthorization } from "../../../components/Authorization/useAuthorization";
import { Row, Col } from "react-bootstrap";
import DocumentUploadCard from "../../../components/CustomControls/DocumentUpload/DocumentUploadCard";
import { Card } from "../../../components/Cards/Card";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  attachmentCategories,
  attachmentEntityType,
} from "../../../variables/Enums";

export const AcceptState = (props) => {
  const { t } = useTranslation();
  const { startup, handleAttachmentChange, setStartup, onSavePatientsObjective } = props;
  const [, , isAuthorized] = useAuthorization();
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(isAuthorized(["Startups.Edit"]));
  }, []);

  const files = useMemo(() => {
    const map = {};
    if (startup?.attachments?.length) {
      startup.attachments.forEach((att) => {
        map[att.attachmentCategoryId] = att;
      });
    }
    return map;
  }, [startup?.attachments]);

  return (
    <>
      <div style={{ height: "20px" }} />
      {/* TODO: Revisar si no faltaría algún documento en su lugar
      <Card
        content={
          <>
            <Row>
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={startup?.attachments.find(
                    (x) =>
                      x.attachmentCategoryId ===
                      attachmentCategories.communicationFile
                  )}
                  legend={"Documentación de la resolución"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            </Row>
          </>
        }
      /> */}
      {/* 
      SOLO ESPAÑA
      <Card
        content={
          <Row>
            {files[attachmentCategories.suitabilityFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={files[attachmentCategories.suitabilityFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
            {files[attachmentCategories.CElmFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={files[attachmentCategories.CElmFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
          </Row>
        }
      /> */}
      {/* Solo España
      <Card
        content={
          <Row className="mt-3">
            {files[attachmentCategories.CEIcFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={files[attachmentCategories.CEIcFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
            {files[attachmentCategories.AEMPSFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={files[attachmentCategories.AEMPSFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
          </Row>
        }
      /> */}
      <Row className="mt-3">
        <Col md={6}>
          {files[attachmentCategories.trialInsuranceFile] && (
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.trialInsuranceFile]}
                  legend="Subir documento"
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              }
            />
          )}
        </Col>

        <Col md={6}>
          {files[attachmentCategories.FDAFile] && (
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.FDAFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              }
            />
          )}
        </Col>
      </Row>
      {/* SE REMUEVE EN STARTUP PARA SER ACCEDIDO EN SOLO EN ISF Y EN EL PROTOCOLO
      <Card
        content={
          <Row className="mt-3">
            {files[attachmentCategories.contractFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={files[attachmentCategories.contractFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
            
            {files[attachmentCategories.protocolFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Protocols}
                  entityId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.protocolFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
          </Row>
        }
      /> */}
      {/* <Card
        content={
          <Row className="mt-3">
            {files[attachmentCategories.FDAFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={files[attachmentCategories.FDAFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
          </Row>
        }
      /> */}
      <Card
        content={
          <Row className="mt-3">
            {files[attachmentCategories.delegationFile] && (
              <Col md={12}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.delegationFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )}
            {/* SOLO SE VERA EN ISF
            {files[attachmentCategories.trainingLogFile] && (
              <Col md={6}>
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  attachment={files[attachmentCategories.trainingLogFile]}
                  legend={"Subir documento"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              </Col>
            )} */}
          </Row>
        }
      />
      <Card
        content={
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <label className="mb-0">
              {t("clinicalTrials.startup.expectedParticipantsCounter")}:
            </label>
            <div className="input-group" style={{ maxWidth: "200px" }}>
              <input
                type="number"
                className="form-control"
                value={startup?.protocol?.patientsObjective ?? ""}
                onChange={(e) => {
                  const raw = e.target.value;
                  if (raw === "") {
                    setStartup((prev) => ({
                      ...prev,
                      protocol: {
                        ...prev.protocol,
                        patientsObjective: "",
                      },
                    }));
                    return;
                  }
                  const value = parseInt(raw, 10);
                  if (!Number.isNaN(value) && value >= 1) {
                    setStartup((prev) => ({
                      ...prev,
                      protocol: {
                        ...prev.protocol,
                        patientsObjective: value,
                      },
                    }));
                  }
                }}
                onBlur={() => {
                  if (!canEdit || !onSavePatientsObjective) return;
                  onSavePatientsObjective();
                }}
                disabled={!canEdit}
                min="1"
              />
            </div>
            <label className="input-group-text">
              {t("clinicalTrials.startup.patientsLabel")}
            </label>
          </div>
        }
      />

      <Row className="mt-3">
        <Col md={6}>
          {files[attachmentCategories.startVisitFile] && (
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.startVisitFile]}
                  legend={"Confirmation Letter"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              }
            />
          )}
        </Col>

        <Col md={6}>
          {files[attachmentCategories.centerActivation] && (
            <Card
              content={
                <DocumentUploadCard
                  attachmentEntityTypeId={attachmentEntityType.Startup}
                  entityId={startup?.id}
                  protocolId={startup?.protocol?.id}
                  attachment={files[attachmentCategories.centerActivation]}
                  legend={"Documento de confirmación por parte del promotor"}
                  onAttachmentChange={handleAttachmentChange}
                  disabled={!canEdit}
                />
              }
            />
          )}
        </Col>
      </Row>

      {startup?.protocol?.status?.code === "StartUp" && canEdit && (
        <button
          type="button"
          className="btn btn-primary"
          style={{ marginBottom: "10px" }}
          onClick={() => {
            props.activateCenter();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          {t("clinicalTrials.general.activateCenter")}
        </button>
      )}
    </>
  );
};

AcceptState.propTypes = {
  activateCenter: PropTypes.func.isRequired,
};

export default AcceptState;
